import { Typography } from '@mui/material'
import { useCategoryQuery } from '@typings/graphql'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

export const SubCategoryBreadcrumb:React.FC = () => {
  const { t } = useTranslation()
  const { subCategoryId } = useParams<{ subCategoryId: string }>()

  const { data } = useCategoryQuery({
    variables: {
      id: subCategoryId as string
    },
    skip: !subCategoryId
  })

  const title = React.useMemo(() => {
    if (!data) {
      return t('categories.unknown')
    }

    return data.category.texts?.title
  }, [data])

  return (
    <Typography
      variant="subtitle1"
      fontWeight="inherit"
    >
      {title}
    </Typography>
  )
}
